import React, { Component } from "react";
import dayjs from "dayjs";
import { s360ConfigService } from "../../Services/S360Config";

class MessageA3 extends Component {
  //   componentDidMount() {
  //     if (this.props.end) {
  //       this.props.actions.sendMessage({
  //         key: "background-image: url(https://s3.ap-south-1.amazonaws.com/finology-images/Select/e1997dc….jpg);",
  //         value: "",
  //       });
  //     }
  //   }
  isHtml(string) {
    console.log(string, "MESSAGE DATA IN A3 HERE ");

    if (string.includes("<") || string.includes("</")) {
      return true;
    } else {
      return false;
    }
  }

  messageTimeClassName = () => {
    return "s360-message-time-received";
    // switch (this.props.message.type) {
    //     // case MessageType.sent: return "s360-message-time-sent";
    //     // case MessageType.received: return "s360-message-time-received";
    //     // case MessageType.info: return "s360-message-time-info";
    //     default: return "";
    // }
  };

  messageBoxClassName = () => {
    return localStorage.getItem("openInFullScreen")
      ? "s360-message-box-received-fs"
      : "s360-message-box-received";
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-box-sent";
    //     case MessageType.received: return "s360-message-box-received";
    //     case MessageType.info: return "s360-message-box-info";
    //     default: return "";
    // }
  };

  messageContainerClassName = () => {
    
    return this.props.config.autoFullScreen
      ? "s360-message-cotainer-received-fs"
      : "s360-message-cotainer-received";
     
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-cotainer-sent";
    //     case MessageType.received: return "s360-message-cotainer-received";
    //     case MessageType.info: return "s360-message-cotainer-info";
    //     default: return "";
    // }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    return {
      background: config.designDetails.senderMessageColor,
      fontFamily: config.designDetails.SenderMessageFont,
      fontSize: config.designDetails.SenderMessageFontSize,
      color: config.designDetails.senderMessageFontColor,
      fontWeight: config.designDetails.senderFontWeight || 400,
    };
    // switch (this.props.message.type) {
    //     case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
    //     case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
    //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     default: return {}
    // }
  };

  messageContainerStyle = () => {
    // let config = this.props.config
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    return {
      fontFamily: config.designDetails.messageFont,
      fontSize: config.designDetails.messageTimeFontSize,
      color: config.designDetails.messageTimeFontColor,
    };
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    // switch (this.props.message.type) {
    //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     default: return {}
    // }
  };

  render() {
    let text = (this?.props?.entry && this?.props?.entry?.text) || "";
    text.replace(/\n/g, "<br/>")
    return (
      <div
        className={this.messageContainerClassName()}
        style={this.messageContainerStyle()}
      >
        {this.isHtml(text) ? (
          <div
            className={this.messageBoxClassName()}
            style={this.messageBoxStyle()}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        ) : (
          <div
            className={this.messageBoxClassName()}
            style={this.messageBoxStyle()}
          >
             
            {text}
          </div>
        )}
        {this.props.sentTimestamp && (
          <div
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs
              .unix(Math.trunc(this.props.sentTimestamp / 1000))
              .format("DD MMM h:mm a")}
          </div>
        )}
      </div>
    );
  }
}

export default MessageA3;
